/** Liga/desliga a UI do funil de público (menu, rotas e CTA). Código permanece no repo. */
export const AUDIENCE_FUNNEL_UI_ENABLED = false;
